const REVEAL_CLASS_MAP = {
  up:         'animate-reveal-up',
  'up-short': 'animate-reveal-up-short',
  down:       'animate-reveal-down',
  'down-short': 'animate-reveal-down-short',
  left:       'animate-reveal-left',
  right:      'animate-reveal-right',
  fade:       'animate-reveal-fade',
  tile:       'animate-reveal-tile',
};

const mobileQuery = window.matchMedia('(max-width: 767px)');

function initScrollReveal() {
  const elements = document.querySelectorAll('[data-reveal]');
  if (!elements.length) return;

  const animating = new Set();

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry.target;
        const direction = el.dataset.reveal;
        const once = el.dataset.revealOnce === 'true';

        if (!entry.isIntersecting) {
          // Don't reset while an animation is still running
          if (animating.has(el)) return;

          // Reset so it can re-animate on next entry
          if (direction === 'letters') {
            el.querySelectorAll('span').forEach(span => {
              span.classList.remove('animate-reveal-letter');
              span.style.opacity = '0';
            });
          } else {
            const animClass = REVEAL_CLASS_MAP[direction];
            if (animClass) el.classList.remove(animClass);
            el.style.opacity = '0';
          }
          return;
        }

        // Letter-by-letter reveal
        if (direction === 'letters') {
          const stagger = parseInt(el.dataset.revealStagger, 10) || 40;
          const spans = el.querySelectorAll('span');
          animating.add(el);
          spans.forEach((span, i) => {
            setTimeout(() => {
              span.style.opacity = '';
              span.classList.add('animate-reveal-letter');
              if (i === spans.length - 1) {
                span.addEventListener('animationend', () => animating.delete(el), { once: true });
              }
            }, i * stagger);
          });
          if (once) observer.unobserve(el);
          return;
        }

        // Directional reveal
        const animClass = REVEAL_CLASS_MAP[direction];
        const delay = parseInt(el.dataset.revealDelay, 10) || 0;

        if (!animClass) return;

        const apply = () => {
          animating.add(el);
          el.style.opacity = '';
          el.classList.add(animClass);
          el.addEventListener('animationend', () => animating.delete(el), { once: true });
        };

        delay > 0 ? setTimeout(apply, delay) : apply();

        if (once) observer.unobserve(el);
      });
    },
    { rootMargin: '0px 0px -150px 0px', threshold: 0.1 }
  );

  elements.forEach((el) => {
    // data-reveal-no-mobile: skip animation entirely on mobile
    if ('revealNoMobile' in el.dataset && mobileQuery.matches) return;

    if (el.dataset.reveal === 'letters') {
      el.querySelectorAll('span').forEach(span => span.style.opacity = '0');
    } else {
      el.style.opacity = '0';
    }
    observer.observe(el);
  });
}

// Scan image wipe — fires after the reveal animation on the same element ends
function initScanAnimate() {
  const el = document.querySelector('[data-scan-animate]');
  if (!el) return;

  // Re-trigger each time the reveal animation completes (not child scan animations)
  el.addEventListener('animationend', (e) => {
    if (e.target === el && e.animationName === 'revealFromLeft') {
      el.classList.add('is-visible');
    }
  });

  // Remove is-visible when out of view so the scan wipe replays on re-entry
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        el.classList.remove('is-visible');
      }
    });
  }, { rootMargin: '0px 0px -150px 0px', threshold: 0.1 });

  observer.observe(el);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initScrollReveal();
    initScanAnimate();
  });
} else {
  initScrollReveal();
  initScanAnimate();
}
